import InternalForm from './Form.es.js';
import FormItem from './FormItem.es.js';
import useForm from './useForm.es.js';

const Form = InternalForm;
Form.Item = FormItem;
Form.useForm = useForm;

export { Form };
